export class DeviceUnionFind {
  private parent: Map<string | number, string | number> = new Map();
  private rank: Map<string | number, number> = new Map();
  private nodeMap: Map<string | number, SelectOptions> = new Map();

  makeSet(x: string | number, option?: SelectOptions) {
    if (!this.parent.has(x)) {
      this.parent.set(x, x);
      this.rank.set(x, 0);
    }
    if (option) {
      this.nodeMap.set(x, option);
    }
  }

  find(x: string | number): string | number {
    if (!this.parent.has(x)) return x;
    const px = this.parent.get(x)!;
    if (px !== x) {
      const root = this.find(px);
      this.parent.set(x, root);
      return root;
    }
    return x;
  }

  findOption(x: string | number): SelectOptions | undefined {
    const root = this.find(x);
    return this.nodeMap.get(root);
  }

  getGroup(x: string | number): (string | number)[] {
    const root = this.find(x);
    const group: (string | number)[] = [];
    this.parent.forEach((_value, key) => {
      if (this.find(key) === root) {
        group.push(key);
      }
    });
    return group;
  }

  union(a: string | number, b: string | number) {
    this.makeSet(a);
    this.makeSet(b);
    const rootA = this.find(a);
    const rootB = this.find(b);
    if (rootA === rootB) return;
    const rankA = this.rank.get(rootA) || 0;
    const rankB = this.rank.get(rootB) || 0;
    if (rankA < rankB) {
      this.parent.set(rootA, rootB);
    } else if (rankA > rankB) {
      this.parent.set(rootB, rootA);
    } else {
      this.parent.set(rootB, rootA);
      this.rank.set(rootA, rankA + 1);
    }
  }
}
